module.exports = __webpack_public_path__ + "img/9_revenue_guru.b644b934.png";